<template>
    <div v-show="$store.state.dialogVisible">
        <div class="loginBox">
            <el-dialog :visible.sync="$store.state.dialogVisible" :before-close="handleClose"
                :close-on-click-modal="false">
                <h2>手机账号登录/注册</h2>
                <el-form :model="loginForm" :rules="rules" ref="loginForm" class="demo-loginForm">
                    <el-form-item prop="mobile">
                        <el-input v-model="loginForm.mobile" placeholder="请输入手机号码"></el-input>
                    </el-form-item>
                    <el-form-item prop="code">
                        <div class="code">
                            <el-input v-model="loginForm.code" placeholder="请输入验证码"
                                @keyup.enter.native="login('loginForm')">
                            </el-input>
                            <el-button class="gain" @click="bindforgetSendCode" :disabled="disabled">
                                {{ btnText }}
                            </el-button>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="btn" :loading="loginLoading" @click="login('loginForm')"
                            @keydown.enter.native="login('loginForm')" type="primary">登录
                        </el-button>
                    </el-form-item>
                    <el-checkbox v-model="checked">
                    </el-checkbox>
                    <!-- /commonProblem?id=6 -->
                    <span style="margin-left:10px;">同意 <router-link target="_blank" to="/commonProblem?id=6" 
                            style="color: #d92a20;text-decoration: none;">《隐私政策》</router-link> 及 <router-link
                            to="/commonProblem?id=7" target="_blank" style="color: #d92a20;text-decoration: none;">《海葵音乐人服务条款》
                        </router-link></span>

                </el-form>
                <el-popover popper-class="slidingPictures" ref="popover" :open-delay="500" trigger="manual"
                    v-model="visible">
                    <div class="sliding-pictures">
                        <div class="vimg">
                            <canvas id="sliderBlock"></canvas>
                            <canvas id="codeImg"></canvas>
                        </div>
                        <div class="slider">
                            <div class="track" :class="{ pintuTrue: puzzle }">
                                {{ tips }}
                            </div>
                            <div class="button el-icon-s-grid" @mousedown.prevent="drag"></div>
                        </div>
                        <div class="operation">
                            <span title="关闭验证码" @click="visible = false" class="el-icon-circle-close"></span>
                            <span title="刷新验证码" @click="canvasInit" class="el-icon-refresh-left"></span>
                        </div>
                    </div>
                </el-popover>
            </el-dialog>
        </div>

        <el-dialog :visible.sync="moveFlag" :close-on-click-modal="false">
            <vue-simple-verify ref="verify" @success="success" movedColor="#d92a20" />
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        var mobile = (rule, value, callback) => {
            let reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'));
            } else {
                if (this.loginForm.checkPass !== '') {
                    this.$refs.loginForm.validateField('请输入手机号');
                }
                callback();
            }
        };
        return {
            countdown: "",//timer---
            loginForm: {
                mobile: '',
                code: '',
            },
            rules: {
                mobile: [
                    { validator: mobile, trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'change' }
                ],
            },
            checked: true,
            type: "",
            btnText: "获取验证码",
            disabled: false,
            loginLoading: false,
            moveFlag: false,
            //拼图是否正确
            puzzle: false,
            // popcode: '点击验证',
            tips: "拖动左边滑块完成上方拼图",
            //滑块x轴数据
            slider: {
                mx: 0,
                bx: 0
            },
            visible: false,
            moveChecked: false,
        }
    },
    watch: {
        $route: {
            handler(val, oldval) {
                if (val.name == 'commonProblem') {
                    this.$store.commit("setDialogVisible", false);
                }
            },
            // 深度观察监听
            deep: true
        },
        "$store.state.dialogVisible": {
            handler(newVal, oldval) {
                if (!newVal) {
                    this.visible = false
                    this.$refs['loginForm'].resetFields();
                }
                if (!newVal && !this.visible) {
                    this.btnText = "获取验证码"
                    this.loginForm = {
                        mobile: '',
                        code: '',
                    }
                    clearInterval(this.countdown);
                } else {

                    this.disabled = false
                }
            }

        },
        "$store.state.user"(val) {
            if (!val.id) {
                this.loginForm.mobile = ''
                this.loginForm.code = ''
            }
        },
        visible(e) {
            if (e === true) {
                this.canvasInit();
                this.puzzle = false;
            }
        }
    },
    methods: {
        canvasInit() {
            const random = (min, max) => {
                return Math.floor(Math.random() * (max - min + 1) + min);
            };
            //x: 254, y: 109
            let mx = random(88, 204),
                bx = random(0, 0),
                y = random(10, 99);

            this.slider = { mx, bx };

            this.draw(mx, bx, y);
        },
        drag(e) {
            let dom = e.target;
            let slider = document.querySelector("#sliderBlock");
            const downCoordinate = { x: e.x, y: e.y };

            let checkx = Number(this.slider.mx) - Number(this.slider.bx);
            let x = 0;
            const move = moveEV => {
                x = moveEV.x - downCoordinate.x;
                if (x >= 221 || x <= 15) return false;
                dom.style.left = x + "px";
                slider.style.left = x + "px";
            };

            const up = () => {
                document.removeEventListener("mousemove", move);
                document.removeEventListener("mouseup", up);
                dom.style.left = "";

                let max = checkx - 1;
                let min = checkx - 20;
                if ((max >= x && x >= min) || x === checkx) {
                    this.puzzle = true;
                    this.tips = "验证成功";
                    this.moveChecked = true
                    this.bindforgetSendCode()
                    // this.popcode = "验证成功"
                    setTimeout(() => {
                        this.visible = false;
                    }, 500);
                } else {
                    this.tips = "验证失败，请重试";
                    this.puzzle = false;
                    this.canvasInit();
                }
            };

            document.addEventListener("mousemove", move);
            document.addEventListener("mouseup", up);
        },
        draw(mx = 200, bx = 20, y = 50) {
            let mainDom = document.querySelector("#codeImg");
            let bg = mainDom.getContext("2d");
            let width = mainDom.width;
            let height = mainDom.height;

            let blockDom = document.querySelector("#sliderBlock");
            let block = blockDom.getContext("2d");
            blockDom.height = height;
            mainDom.height = height;

            let imgsrc = require("../../../static/other/back.jpg");
            let img = document.createElement("img");
            img.style.objectFit = "scale-down";
            img.src = imgsrc;
            img.onload = function () {
                bg.drawImage(img, 0, 0, width, height);
                block.drawImage(img, 0, 0, width, height);
            };

            let mainxy = { x: mx, y: y, r: 9 };
            let blockxy = { x: bx, y: y, r: 9 };
            this.drawBlock(bg, mainxy, "fill");
            this.drawBlock(block, blockxy, "clip");
        },
        //绘制拼图
        drawBlock(ctx, xy = { x: 254, y: 109, r: 9 }, type) {
            let x = xy.x,
                y = xy.y,
                r = xy.r,
                w = 40;
            let PI = Math.PI;
            //绘制
            ctx.beginPath();
            //left
            ctx.moveTo(x, y);
            //top
            ctx.arc(x + (w + 5) / 2, y, r, -PI, 0, true);
            ctx.lineTo(x + w + 5, y);
            //right
            ctx.arc(x + w + 5, y + w / 2, r, 1.5 * PI, 0.5 * PI, false);
            ctx.lineTo(x + w + 5, y + w);
            //bottom
            ctx.arc(x + (w + 5) / 2, y + w, r, 0, PI, false);
            ctx.lineTo(x, y + w);
            ctx.arc(x, y + w / 2, r, 0.5 * PI, 1.5 * PI, true);
            ctx.lineTo(x, y);
            ctx.lineWidth = 1;
            ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
            ctx.strokeStyle = "rgba(255, 255, 255, 0.5)";
            ctx.stroke();
            ctx[type]();
            ctx.globalCompositeOperation = "xor";
        },
        handleClose() {
            this.visible = false
            this.$store.commit('setDialogVisible', false)
        },
        login(formName) {
            if (!this.checked) return this.$msg("error", '提示', '请先阅读隐私政策')
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loginLoading = true
                    this.$home.login(this.loginForm).then(res => {
                        if (res.code == 200) {
                            this.loginLoading = false
                            this.$store.commit('setDialogVisible', false)
                            this.$store.commit('setUser', res.data)
                            sessionStorage.setItem('att_status', res.data.att_status)
                            localStorage.setItem('prompt', res.data.prompt) //是否需要不再提醒
                            // 更新一下首页的数据
                            this.$bus.$emit('homeShow')
                        } else {
                            this.$msg("error", '提示', res.msg);
                            this.loginLoading = false
                        }
                    }).catch(err => {
                        this.loginLoading = false
                    })

                } else {
                    return false;
                }
            });
        },
        bindforgetSendCode() {
            let reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
            if (reg.test(this.loginForm.mobile)) {

                if (!this.moveChecked) {
                    this.visible = !this.visible
                } else {

                    let data = {
                        mobile: this.loginForm.mobile,
                        type: 1
                    }
                    this.$home.getCode(data).then(res => {
                        if (res.code == 200) {
                            this.disabled = true;
                            this.btnText = "请稍候...";
                            setTimeout(() => {
                                this.doLoop(60);
                            }, 500);
                        } else {
                            this.disabled = true;
                            this.$msg('error', '提示', res.msg)
                        }
                    }).catch(err => {
                    })
                    this.moveChecked = false
                }

            } else {
                this.$msg('error', '提示', '请输入正确的手机号')
            }
        },
        doLoop: function (seconds) {
            seconds = seconds ? seconds : 60;
            this.btnText = seconds + "s后获取";
            this.countdown = setInterval(() => {
                if (seconds > 0) {
                    this.btnText = seconds + "s后获取";
                    --seconds;
                } else {
                    this.btnText = "获取验证码";
                    this.disabled = false;
                    clearInterval(this.countdown);
                }
            }, 1000);
        },
        success(val) {
            this.moveChecked = true
            setTimeout(() => {
                this.visible = !this.visible
                // this.moveFlag = false

            }, 1000);
        },
    }
}
</script>
<style>
.slidingPictures {
    padding: 0;
    width: 300px;
    border-radius: 2px;
}
</style>
<style lang="scss" scoped>
::v-deep .el-popover {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

::v-deep .el-input__inner {
    height: 42px;
    border: 0.5px solid #dedede;
    font-family: PingFang SC-Medium,PingFang SC;
}


.sliding-pictures {
    width: 100%;

    .vimg {
        width: 100%;
        height: 170px;

        #codeImg,
        #sliderBlock {
            padding: 7px 7px 0 7px;
            width: inherit;
            height: inherit;
        }

        #codeImg {
            //display: none;
        }

        #sliderBlock {
            position: absolute;
            z-index: 4000;
        }
    }

    .slider {
        width: 96%;
        height: 65px;
        border-bottom: #c7c9d0 1px solid;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .track {
            margin-left: 7px;
            width: 286px;
            height: 38px;
            background: rgba(28, 136, 188, 0.5);
            border-radius: 25px;
            font-size: 14px;
            line-height: 38px;
            padding-right: 15px;
            padding-left: 70px;
        }

        .pintuTrue {
            background: #67c23a;
            color: #ffffff;
        }

        .button {
            position: absolute;
            width: 50px;
            height: 50px;
            line-height: 48px;
            background: #ffffff;
            box-shadow: #b9bdc8 0 0 3px;
            border-radius: 50%;
            left: 18px;
            text-align: center;
            font-size: 28px;
            color: #3e5d8b;

            &:hover {
                color: #2181bd;
            }
        }
    }

    .operation {
        width: 100%;
        height: 40px;

        >span {
            color: #9fa3ac;
            display: inline-block;
            width: 40px;
            font-size: 25px;
            line-height: 40px;
            text-align: center;

            &:hover {
                background: #e2e8f5;
            }
        }
    }
}

::v-deep .simple-verify .verify-bar {
    top: 0px !important;
    margin: auto;
}

.code {
    position: relative;

    .gain {
        position: absolute;
        right: 4px;
        border-radius: 3px;
        background: #F0F4F5;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        padding: 0 9px;
        display: flex;
        align-items: center;
        height: 36px;
        cursor: pointer;
        top: 50%;
        transform: translateY(-50%);
        border: none;
    }
}

::v-deep .el-dialog {
    margin-top: 0 !important;
    padding: 0;

    .el-dialog__body {
        display: flex;
        justify-content: center;
    }
}

.loginBox {

    ::v-deep .el-dialog {
        width: 690px;
        background: #FFFFFF;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        padding: 54px 120px;

        .el-dialog__header {
            padding: 0;
        }

        .el-dialog__body {
            padding: 0;
            display: block;
        }

        h2 {
            margin-bottom: 50px;
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
        }

        .btn {
            height: 42px;
            // background: #D92A20;
            border-radius: 3px 3px 3px 3px;
            opacity: 1;
            color: white;
            text-align: center;
            font-size: 15px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            cursor: pointer;
            width: 100%;

            span {
                color: #FFFFFF;
                font-size: 15px;
            }
        }

        span {
            font-size: 10px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
        }
    }
}
</style>